import { Pipe, PipeTransform } from '@angular/core';
import { isEmpty } from '../utils/object-util';

@Pipe({ name: 'stringToArray' })
export class StringToArrayPipe implements PipeTransform {
  transform(val: string, separator: string): string[] {
    return val ? val.split(separator).filter((s) => !isEmpty(s)) : [];
  }
}
